import { render, staticRenderFns } from "./index.vue?vue&type=template&id=2e5d39ff&scoped=true&"
import script from "./index.vue?vue&type=script&lang=js&"
export * from "./index.vue?vue&type=script&lang=js&"
import style0 from "../../assets/css/addRounds.scss?vue&type=style&index=0&id=2e5d39ff&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2e5d39ff",
  null
  
)

export default component.exports